/* eslint-disable */
import React, { useState, memo, useLayoutEffect, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Paper, { PaperProps } from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import Checkbox from '@mui/material/Checkbox';
import srv from '../../services';
import { isMobile, isTablet } from 'react-device-detect';

const useStyles = makeStyles({
 dialog: {
  height: '100%',
 },

 dialogContainer: {
  '& .MuiDialog-container': {
   justifyContent: 'center',
   justifyItems: 'center',
   alignItems: 'center',
   alignContent: 'center',
   display: 'flex',
   width: '100%',
   backgroundColor: 'none',
   overflow: 'hidden',
   height: '1000px',
   paddingLeft: '-50% !important',
  },
  '& .MuiTypography-root': {
   display: 'flex',
   alignItems: 'center',
  },
  '& .MuiDialogContent-root': {
   overflow: 'hidden',
   padding: '0 !important',
   margin: '0 !important',
  },
  '& .MuiDialog-paper': {
   height: '735px',
  },
 },
 dialogTitle: {
  height: '20px',
  border: '1px solid #cacaca',
  color: 'black !important',
 },
 container: {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  padding: 0,
  flexDirection: 'row',
 },
 headerTitle: {
  fontWeight: 'bold',
  color: 'white',
  //fontSize: '16px',
  fontFamily: 'calibri',
  //padding: '5px 40px',
  borderRadius: '10px',
 },
 banner: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
 },
});

function PaperComponent(props: PaperProps) {
 return (
  <Draggable
   handle="#draggable-dialog-title"
   cancel={'[class*="MuiDialogContent-root"]'}
  >
   <Paper {...props} />
  </Draggable>
 );
}

/**
 * Окно банера.
 * @param props
 * @returns
 */
const DialogBanner = (props: any) => {
 const classes = useStyles();

 const [open, setOpen] = useState(props.showBanner);
 const [showVostokBanner, setShowVostokBanner] = React.useState(false);

 useLayoutEffect(() => {
  setOpen(props.showBanner);
 }, [props.showBanner]);

 const closeDialogHandler = () => {
  setOpen(false);
 };

 const handleShowBanner = (event: React.ChangeEvent<HTMLInputElement>) => {
  const checked = event.target.checked;
  const value = Number(checked);

  const payload = {
   newValue: `${Number(!value)}`,
  };

  srv.setShowVostokBanner(payload).then(() => {
   setShowVostokBanner(!showVostokBanner);
  });
 };

 const handleShowBannerTouch = (event: any) => {
  const checked = event.target.checked;
  const value = Number(checked);

  const payload = {
   newValue: `${Number(value)}`,
  };

  srv.setShowVostokBanner(payload).then(() => {
   setShowVostokBanner(!showVostokBanner);
  });
 };

 return (
  <div>
   <Dialog
    className={classes.dialogContainer}
    open={open}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
    PaperProps={{
     sx: {
      width: isMobile ? '350px' : '700px',
      height: isMobile ? '351px' : '702px',
      maxWidth: isMobile ? '350px' : '700px',
      maxHeight: isMobile ? '350px' : '700px',
      overflow: 'hidden',
      marginLeft: isMobile ? '-22% !important' : '',
      marginTop: isMobile ? '-20%' : '',
     },
    }}
   >
    <DialogTitle
     className={classes.dialogTitle}
     style={{
      cursor: 'move',
      backgroundColor: 'black',
      border: '1px black solid',
     }}
     id="draggable-dialog-title"
    >
     <div className={classes.container}>
      <div
       className={classes.headerTitle}
       style={{
        color: 'white',
        marginLeft: isMobile ? '-100px' : '-40px',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        padding: isMobile ? '5px 20px' : '5px 40px',
        fontSize: isMobile ? '10px' : '16px',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        alignItems: 'center',
       }}
      >
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
        }}
       >
        {isMobile ? '' : 'Электронный документооборот с ЭК «Восток»'}

        <div
         style={{
          display: 'flex',
          flexDirection: 'row',
          marginLeft: isMobile ? '10px' : '30px',
          justifyContent: 'center',
          justifyItems: 'center',
          alignContent: 'center',
          alignItems: 'center',
         }}
        >
         <div style={{ marginRight: '8px' }}>
          <label>{isMobile ? 'Не показывать' : 'Больше не показывать'}</label>
         </div>
         <div>
          <label>
           <Checkbox
            onChange={handleShowBanner}
            onTouchStart={handleShowBannerTouch}
            checked={showVostokBanner}
            style={{ color: 'white' }}
           />
          </label>
         </div>
        </div>
       </div>
      </div>

      <div
       style={{
        cursor: isMobile ? 'default' : 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        alignItems: 'center',
       }}
      >
       {isMobile ? (
        <CloseIcon
         style={{
          marginRight: '-15px',
          fontWeight: 800,
          color: 'white',
          cursor: isMobile ? 'default' : 'pointer',
         }}
         onTouchStart={closeDialogHandler}
        />
       ) : (
        <CloseIcon
         style={{
          marginRight: '-15px',
          fontWeight: 800,
          color: 'white',
          cursor: isMobile ? 'default' : 'pointer',
         }}
         onClick={closeDialogHandler}
        />
       )}
      </div>
     </div>
    </DialogTitle>
    <DialogContent className={classes.dialog}>
     <div>
      <img
       src="../../VostokBannerLogoSmall.png"
       alt="Восток Баннер"
       className={classes.banner}
       style={{
        height: isMobile ? '351px' : '702px',
        width: isMobile ? '350px' : '700px',
       }}
      ></img>
     </div>
    </DialogContent>
   </Dialog>
  </div>
 );
};

export default memo(DialogBanner);
